import { actions as actions$1 } from '@grandvisionhq/state';

/*
 * UnlinkOrder actions
 */ const unlinkOrder = actions$1.action('auth/orders/unlink', actions$1.payload());
const unlinkOrderSuccess = actions$1.action('auth/orders/unlink-success');
const unlinkOrderFailed = actions$1.action('auth/orders/unlink-failed', (error)=>({
        error
    })
);

export { unlinkOrder, unlinkOrderFailed, unlinkOrderSuccess };
//# sourceMappingURL=actions.js.map
